import { button, element } from "@groundspark/browser-ui";

export function breadcrumbs(
  currentLabel: string,
  ancestors: readonly { label: string; onSelect: () => void | Promise<void> }[],
): HTMLElement {
  const current = element("span", null, currentLabel);
  current.setAttribute("aria-current", "page");
  const items = [
    ...ancestors.map(({ label, onSelect }) => button(label, "breadcrumbs__link", onSelect)),
    current,
  ];
  const list = element("ol");
  for (const [index, item] of items.entries()) {
    const separator = element("span", "muted", "/");
    separator.setAttribute("aria-hidden", "true");
    list.append(element("li", null, index > 0 ? separator : null, item));
  }
  const navigation = element("nav", "breadcrumbs", list);
  navigation.setAttribute("aria-label", "Breadcrumb");
  return navigation;
}
